// i18nOwl-ignore [app-cohort.medias.image.title]
import MediaContentCohortImage from '@cohort/components-xps/components/contents/apps/cohort/image/MediaContentCohortImage';
import type {ContentMedia} from '@cohort/merchants/apps';
import CohortImageMediaConfigComponent from '@cohort/merchants/apps/cohort/medias/image/ConfigComponent';
import CohortImageVisualPreview from '@cohort/merchants/apps/cohort/medias/image/VisualPreview';
import type {CohortImageMediaStruct} from '@cohort/shared/apps/cohort/medias/image';
import {CohortImageMediaSpec} from '@cohort/shared/apps/cohort/medias/image';
import {Image} from '@phosphor-icons/react';
export const CohortMediaImage: ContentMedia<CohortImageMediaStruct> = {
  spec: CohortImageMediaSpec,
  configComponent: CohortImageMediaConfigComponent,
  getTitle: t => t('medias.image.title', {ns: 'app-cohort'}),
  mediaContent: MediaContentCohortImage,
  icon: ({size, textColor}) => <Image size={size} className={textColor} />,
  visualPreview: CohortImageVisualPreview,
};
